import React, { createContext, useState } from "react";
import { formatDate } from "../../../../utils/formatDate";

const MinClienteContext = createContext();

const MinClienteContextProvider = ({ children }) => {
  const [generalCustomerId, setGeneralCustomerId] = useState(null);
  const [generalTypeSubscription, setGeneralTypeSubscription] = useState({
    description: "CPF",
    value: "cpf",
  });
  const [generalCpfCnpj, setGeneralCpfCnpj] = useState("");
  const [generalName, setGeneralName] = useState("");
  const [generalFantasy, setGeneralFantasy] = useState("");
  const [generalCep, setGeneralCep] = useState("");
  const [generalAddress, setGeneralAddress] = useState("");
  const [generalNumber, setGeneralNumber] = useState("");
  const [generalComplement, setGeneralComplement] = useState("");
  const [generalDistrict, setGeneralDistrict] = useState("");
  const [generalUf, setGeneralUf] = useState(null);
  const [generalCounty, setGeneralCounty] = useState(null);
  const [generalNation, setGeneralNation] = useState(null);
  const [generalTelephone1, setGeneralTelephone1] = useState("");
  const [generalTelephone2, setGeneralTelephone2] = useState("");
  const [generalTelephone3, setGeneralTelephone3] = useState("");
  const [generalEmail, setGeneralEmail] = useState("");
  const [generalRg, setGeneralRg] = useState("");
  const [generalIe, setGeneralIe] = useState("");
  const [generalSimpleNational, setGeneralSimpleNational] = useState(false);
  const [generalFinalCustomer, setGeneralFinalCustomer] = useState(true);
  const [generalIm, setGeneralIm] = useState("");
  const [generalCheckBudget, setGeneralCheckBudget] = useState(true);
  const [generalCheckNfe, setGeneralCheckNfe] = useState(true);
  const [generalCheckFinancial, setGeneralCheckFinancial] = useState(true);
  const [generalIeIndication, setGeneralIeIndication] = useState({
    label: "Não Contribuinte",
    value: 0,
    codigo: "9",
  });
  const [generalActive, setGeneralActive] = useState(true);
  const [generalMatriz, setGeneralMatriz] = useState(null);
  const [generalSendEmail, setGeneralSendEmail] = useState(true);
  const [generalDateInitial, setGeneralDateInitial] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );
  const [generalWebsite, setGeneralWebsite] = useState("");

  const [expanded, setExpanded] = useState({ general: true });
  const [listCommercialRegion, setListCommercialRegion] = useState([]);
  const [listRiskClass, setListRiskClass] = useState([]);
  const [listUf, setListUf] = useState([]);
  const [listBank, setListBank] = useState([]);
  const [listCounty, setListCounty] = useState([]);
  const [listNation, setListNation] = useState([]);
  const [listSalesMan, setListSalesMan] = useState([]);
  const [listCommercialPartner, setListCommercialPartner] = useState([]);
  const [listDefaultPayment, setListDefaultPayment] = useState([]);
  const [listTypePayment, setListTypePayment] = useState([]);
  const [listTableShipping, setListTableShipping] = useState([]);
  const [listShippingCompany, setListShippingCompany] = useState([]);
  const [listCompany, setListCompany] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingInputs, setLoadingInputs] = useState({});
  const [errors, setErrors] = useState({});

  return (
    <MinClienteContext.Provider
      value={{
        generalCustomerId,
        setGeneralCustomerId,
        generalTypeSubscription,
        setGeneralTypeSubscription,
        generalCpfCnpj,
        setGeneralCpfCnpj,
        generalName,
        setGeneralName,
        generalFantasy,
        setGeneralFantasy,
        generalCep,
        setGeneralCep,
        generalAddress,
        setGeneralAddress,
        generalNumber,
        setGeneralNumber,
        generalComplement,
        setGeneralComplement,
        generalDistrict,
        setGeneralDistrict,
        generalUf,
        setGeneralUf,
        generalCounty,
        setGeneralCounty,
        generalNation,
        setGeneralNation,
        generalTelephone1,
        setGeneralTelephone1,
        generalTelephone2,
        setGeneralTelephone2,
        generalTelephone3,
        setGeneralTelephone3,
        generalEmail,
        setGeneralEmail,
        generalRg,
        setGeneralRg,
        generalIe,
        setGeneralIe,
        generalSimpleNational,
        setGeneralSimpleNational,
        generalFinalCustomer,
        setGeneralFinalCustomer,
        generalIm,
        setGeneralIm,
        generalCheckBudget,
        setGeneralCheckBudget,
        generalCheckNfe,
        setGeneralCheckNfe,
        generalCheckFinancial,
        setGeneralCheckFinancial,
        generalActive,
        setGeneralActive,
        generalMatriz,
        setGeneralMatriz,
        generalSendEmail,
        setGeneralSendEmail,
        generalDateInitial,
        setGeneralDateInitial,
        generalIeIndication,
        setGeneralIeIndication,
        generalWebsite,
        setGeneralWebsite,
        expanded,
        setExpanded,
        listCommercialRegion,
        setListCommercialRegion,
        listRiskClass,
        setListRiskClass,
        listUf,
        setListUf,
        listBank,
        setListBank,
        listCounty,
        setListCounty,
        listNation,
        setListNation,
        listSalesMan,
        setListSalesMan,
        listCommercialPartner,
        setListCommercialPartner,
        listDefaultPayment,
        setListDefaultPayment,
        listTypePayment,
        setListTypePayment,
        listTableShipping,
        setListTableShipping,
        listShippingCompany,
        setListShippingCompany,
        listCompany,
        setListCompany,
        loading,
        setLoading,
        loadingInputs,
        setLoadingInputs,
        errors,
        setErrors,
      }}
    >
      {children}
    </MinClienteContext.Provider>
  );
};

export { MinClienteContextProvider, MinClienteContext };
